<template>
  <svg-icon :name="batteryData.icon" class="svg-icon-without-hover mr-2" :width="28">
    <template #additionalContent>
      <text
        v-if="batteryData.lowChargeMessage"
        x="13"
        y="12"
        class="connection-info"
        fill="white"
        text-anchor="middle"
      >
        {{ batteryData.lowChargeMessage }}
      </text>
    </template>
  </svg-icon>
</template>

<script>

const BATTERY_CONFIG = {
  DEVICE: {
    thresholds: [85, 70, 45, 20, 10],
    icons: ['charge-l5', 'charge-l4', 'charge-l3', 'charge-l2', 'charge-low', 'charge-empty']
  },
  PHONE: {
    thresholds: [80, 60, 40, 20, 10],
    icons: ['charge-l5', 'charge-l4', 'charge-l3', 'charge-l2', 'charge-low', 'charge-empty']
  }
}

const LOW_BATTERY_THRESHOLD = 20

export default {
  name: 'BatteryLevelIcon',
  components: {
    SvgIcon: () => import('@/components/SvgIcon.vue')
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: value => ['DEVICE', 'PHONE'].includes(value)
    },
    level: {
      type: Number,
      required: false
    },
    isCharging: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    batteryData() {
      return this.getBatteryInfo(this.level, this.type, this.isCharging)
    }
  },
  methods: {
    getBatteryInfo(charge, deviceType, isCharging) {
      const config = BATTERY_CONFIG[deviceType]
      const isUnknown = !charge || charge <= 0

      if (isUnknown) {
        return {
          icon: 'charge-l5',
          lowChargeMessage: ''
        }
      }

      if (isCharging) {
        return {
          icon: 'charging',
          lowChargeMessage: ''
        }
      }

      // Ищем в словаре иконку, соответствующую уровню заряда
      let levelIndex = config.thresholds.findIndex(t => charge > t)
      if (levelIndex === -1) {
        levelIndex = config.icons.length - 1
      }

      return {
        icon: config.icons[levelIndex],
        lowChargeMessage: charge <= LOW_BATTERY_THRESHOLD ? `${charge}%` : null
      }
    },
  }
}
</script>
